import { Validator } from '@vista-digital/validator';
export const orderCartEventsValidator = Validator.object({
    onActionButtonClicked: Validator.optional(Validator.fn()),
    onTicketsActionButtonClicked: Validator.optional(Validator.fn()),
    onItemsActionButtonClicked: Validator.optional(Validator.fn())
});
